<div id="openExtendsUploadFileMovement" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content" *ngIf="item != null">
      <div class="modal-header">
        <h4 class="modal-title">Subir archivo constancia</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-6 form-group">
                  <label>N° voucher</label>
                  <input type="text" class="form-control" disabled value="{{item.nro_voucher}}">
                </div>
                <div class="col-lg-6 form-group">
                  <label>Fecha</label>
                  <input type="text" class="form-control" disabled value="{{item.date_movement  |  date: 'YYYY-MM-dd'}}">
                </div>
                <div class="col-lg-6 form-group">
                  <label>Medio pago</label>
                  <input type="text" class="form-control" disabled value="{{item.paymethod.description}}">
                </div>
                <div class="col-lg-6 form-group">
                  <label>Total {{toolsService.momeySol()}}</label>
                  <input type="text" class="form-control" disabled value="{{item.amount}}">
                </div>
                <div class="col-lg-12 form-group">
                  <label>Adjuntar archivo (png, jpg)</label>
                  <input id="fileUrlImage" type="file" accept="image/png, image/jpeg, image/jpg" (change)="onFileSelected($event)">
                  <!-- <input type="text" class="form-control" disabled value="{{item.nro_voucher}}"> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
            (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-primary">Guardar </button>
        </div>
      </form>
    </div>
  </div>
</div>